import { Container } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import fr from "dayjs/locale/fr";
import { SnackbarProvider } from "notistack";
import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppThemeProvider from "./AppTheme";
import LoadingAnimation from "./components/generic/LoadingAnimation";
import Header from "./components/Header";
import ProtectedContent from "./components/routing/ProtectedContent";
import ScheduledTasksTicker from "./components/ScheduledTasksTicker";
import { AbsolutePages } from "./constants/Sitemap";
import { AuthProvider } from "./hooks/Auth";
import { CommissionVisibilityProvider } from "./hooks/specialized/CommissionVisibility";

const EmailValidation = lazy(() => import("./pages/EmailValidation"));
const Home = lazy(() => import("./pages/Home"));
const Login = lazy(() => import("./pages/Login"));
const MyAccount = lazy(() => import("./pages/MyAccount"));
const PasswordReset = lazy(() => import("./pages/PasswordReset"));

const SellerRouter = lazy(() => import("./pages/seller/SellerRouter"));
const AdminRouter = lazy(() => import("./pages/admin/AdminRouter"));

const routerBasename = new URL(process.env.PUBLIC_URL || "/", window.location.origin).pathname.replace(/\/$/, "") || "/";

function App() {
  return (
    <>
      <AppThemeProvider>
        <AuthProvider>
          <CommissionVisibilityProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={fr}>
              <SnackbarProvider anchorOrigin={{ horizontal: "right", vertical: "bottom" }} autoHideDuration={3500}>
                <BrowserRouter basename={routerBasename}>
                  <Header />
                  <Container sx={{ paddingTop: 3, paddingBottom: 3 }}>
                    <Suspense fallback={<LoadingAnimation />}>
                      <Routes>
                        <Route path={AbsolutePages.login} element={<Login />} />
                        <Route path={AbsolutePages.passwordReset} element={<PasswordReset />} />
                        <Route path={AbsolutePages.passwordSetup} element={<PasswordReset />} />
                        <Route path={AbsolutePages.emailValidation} element={<EmailValidation />} />
                        <Route
                          path={AbsolutePages.currentUserAccount}
                          element={<ProtectedContent component={MyAccount} />}
                        />

                        <Route
                          path={`${AbsolutePages.seller.hub}/*`}
                          element={
                            <ProtectedContent component={SellerRouter} authorizeFunc={(auth) => auth.isSeller} />
                          }
                        />
                        <Route
                          path={`${AbsolutePages.admin.hub}/*`}
                          element={<ProtectedContent component={AdminRouter} authorizeFunc={(auth) => auth.isAdmin} />}
                        />

                        <Route path="*" element={<Home />} />
                      </Routes>
                    </Suspense>
                  </Container>
                </BrowserRouter>
              </SnackbarProvider>
            </LocalizationProvider>
          </CommissionVisibilityProvider>
        </AuthProvider>
      </AppThemeProvider>
      <ScheduledTasksTicker />
    </>
  );
}

export default App;
